// extracted by mini-css-extract-plugin
module.exports = {"feature-details":"feature-details_component_feature-details__LaBw1"};